<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Comandos MTT</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-text-field
        solo
        :label="$t('search')"
        append-icon="mdi-magnify"
        v-model="search"
        color="#8FAE2D"
      ></v-text-field>

      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.name" label="Comando"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.commands" label="Categoría"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.fat" label="Tiempo"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.carbs" label="Activado"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.protein" label="Comentario"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">Cancelar</v-btn>
            <v-btn color="blue darken-1" flat @click.native="save">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table 
      :headers="headers" 
      :items="desserts" 
      hide-actions class="elevation-1"
      :footer-props="{
        'items-per-page-text': $t('rows'),
        'items-per-page-all-text': $t('all'),
      }"
      >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.commands }}</td>
        <td class="justify-left layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">settings</v-icon>
          <v-icon small @click="editItem(props.item)">swap_vert</v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
      <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }} </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "commandsList",
  data: () => ({
    dialog: false,
    headers: [
      {
        text: "COMANDOS",
        align: "left",
        sortable: false,
        value: "name"
      },
      { text: "CATEGORÍA", value: "commands" },
      { text: "ACCIONES", value: "name", sortable: false }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      commands: 0,
      fat: 0,
      carbs: 0,
      protein: 0
    },
    defaultItem: {
      name: "",
      commands: 0,
      fat: 0,
      carbs: 0,
      protein: 0
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Configurar comando" : "Editar comando";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.desserts = [
        {
          name: "Reportes periódicos de AlertTruck",
          commands: "Auto-reportes",
          period: 0,
          enableOdoReport: 0,
          motionlessTimeout: 0,
          abruptChange: 0,
          motionTime: 0,
          speedThres: 0
        },
        {
          name: "Exceso de RPM",
          commands: "Reportes por evento",
          enable: 0,
          rpmThres: 0
        },
        {
          name: "Apagado rápido",
          commands: "Reportes por evento",
          minShutOffTime: 0
        },
        {
          name: "Exceso de tiempo de embrague",
          commands: "Reportes por evento",
          timeInMotion: 0,
          timeMotionless: 0
        },
        {
          name: "Exceso de tiempo de freno",
          commands: "Reportes por evento",
          maxBrakeTime: 0,
          thresholdSpeed: 0
        },
        {
          name: "Exceso de carga del motor",
          commands: "Reportes por evento",
          loadThres: 0
        },
        {
          name: "Alto porcentaje de tiempo ralentí",
          commands: "Reportes por evento",
          idlePercent: 0,
          thresHours: 0,
          idleTimeRp: 0
        },
        {
          name: "Cambios abruptos de velocidad",
          commands: "Reportes por evento",
          speed1: 0,
          speed2: 0
        },
        {
          name: "Control crucero",
          commands: "Reportes por evento",
          fat: 25.0,
          carbs: 51,
          protein: 4.9
        },
        {
          name: "Exceso de velocidad",
          commands: "Reportes por evento",
          fat: 26.0,
          carbs: 65,
          protein: 7
        },
        {
          name: "Economía de combustible",
          commands: "Reportes por evento",
          fat: 26.0,
          carbs: 65,
          protein: 7
        },
        {
          name: "PTO",
          commands: "Reportes por evento",
          fat: 26.0,
          carbs: 65,
          protein: 7
        },
        {
          name: "Tiempo de descanso",
          commands: "Reportes por evento",
          fat: 26.0,
          carbs: 65,
          protein: 7
        },
        {
          name: "Configuración de Histéresis",
          commands: "Reportes por evento",
          fat: 26.0,
          carbs: 65,
          protein: 7
        },
        {
          name: "Marca de viaje manual",
          commands: "Reportes por evento",
          fat: 26.0,
          carbs: 65,
          protein: 7
        },
        {
          name: "Reinicio de valores de fabrica de AT",
          commands: "Reportes por evento",
          fat: 26.0,
          carbs: 65,
          protein: 7
        }
      ];
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>

<style scoped>
</style>